module.exports = __webpack_public_path__ + "img/qr-placeholder.898ca9fa.png";